export const AUTH_TOKEN = "@biztrip.authtoken";
export const AGENCY_CUSTOMER_ID = "@biztrip.customerid";
export const DATE_TOKEN = "@biztrip.datetoken";
export const PROFILE = "@biztrip.profile";
export const REDIRECT_TO = "@biztrip.redirectto";
